











































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ApplicantList } from '@/@types/LibraryComponent.ts';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    AccountIcon,
  }
})
export default class ApplicantListCard extends Vue {
  @Prop({ type: Array, default: null }) private applicantList!: Array<ApplicantList>;
  /** 週間の稼働時間 */
  private weeklyFullOperationTime: number = 40;
  private getStatusName(status: string) {
    switch (status) {
      case '1':
        return '未対応';
      case '2':
        return '対応中';
      case '3':
        return '対応済み';
      default:
        return '未対応';
    }
  };
}
